import classNames from 'classnames';
import { isNil } from 'lodash-es';

import styles from './GradeClassNumberLabel.module.scss';

interface Props {
  gradeLabel?: string;
  classNameLabel?: string;
  attendanceNumberLabel?: number;
  className?: string;
}

const GradeClassNumberLabel: React.FC<Props> = ({
  gradeLabel,
  classNameLabel,
  attendanceNumberLabel,
  className,
}) => (
  <label className={classNames(styles.label, className)}>
    {gradeLabel &&
      (classNameLabel || !isNil(attendanceNumberLabel) ? (
        <span>
          {gradeLabel}
          <span className={styles.grade}>-</span>
        </span>
      ) : (
        <span>{gradeLabel}</span>
      ))}
    {classNameLabel &&
      (!isNil(attendanceNumberLabel) ? (
        <span className={styles.className}>{classNameLabel}組</span>
      ) : (
        <span>{classNameLabel}組</span>
      ))}
    {!isNil(attendanceNumberLabel) ? (
      <span>{attendanceNumberLabel}番</span>
    ) : null}
  </label>
);

export default GradeClassNumberLabel;
